var CustomerIOClient = {
	init: function(clientID) {
		window._cio = window._cio || [];

		(function() {
			var a,b,c;a=function(f){return function(){window._cio.push([f].
			concat(Array.prototype.slice.call(arguments,0)))}};b=["identify",
			"track"];for(c=0;c<b.length;c++){window._cio[b[c]]=a(b[c])};
			var t = document.createElement('script'),
				s = document.getElementsByTagName('script')[0];
			t.async = true;
			t.id    = 'cio-tracker';
			t.setAttribute('data-site-id', clientID);
			t.src = 'https://assets.customer.io/assets/track.js';
			s.parentNode.insertBefore(t, s);
		})();
	},

	identify: function(user) {
		if (user.email && !$wr.isDevelopment() && !$wr.isStaging()) {
			var userData = {
				id: CustomerIOClient.getUserIdentifier(user),
				email: user.email,
				environment: $wr.environment(),
				demo: user.demo,
				title: user.title,
				first_name: user.first_name,
				last_name: user.last_name,
				first_active: user.first_active,
				last_active: user.last_active,
				role: user.role,
				product: user.product,
				api_version: user.api_version,
				grade_level: user.grade_level,
				timezone: user.time_zone_region,

				account_annual: (user.account || {}).annual,
				account_existing_plan_value: (user.account || {}).existing_plan_value,
				account_has_credit_card: (user.account || {}).has_credit_card,
				account_max_student_list_count: (user.account || {}).max_student_list_count,
				account_max_students_count: (user.account || {}).max_students_count,
				account_next_charge_cents: (user.account || {}).next_charge_cents,
				account_next_charge_time: (user.account || {}).next_charge_time,
				account_plan_has_rlds: (user.account || {}).plan_has_rlds,
				account_plan_payment_status: (user.account || {}).plan_payment_status,
				account_plan_student_list_count: (user.account || {}).plan_student_list_count,
				account_plan_type: (user.account || {}).plan_type,

			}

			_cio.identify(userData);
		}
	},

	event: function(user, name, data = {}) {
		CustomerIOClient.identify(user);

		if (user.email && !$wr.isDevelopment() && !$wr.isStaging()) {
			_cio.track(name, data);
		}
	},

	getUserIdentifier: function(user) {
		return $wr.environment().substring(0,3) + "-" + user.id;
	}

}

module.exports = CustomerIOClient;


// WEBPACK FOOTER //
// ./modules/lib/integrations/CustomerIOClient.js